//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Vyp.WebControls.VypraveniSettingsForm.ts                 </Name>
//    <Description> Uživatelské nastavení SPI.                              </Description>
//    <Author>      JSindelka                                                      </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2018                            </Copyright>
//    <Created>     2018-05-22                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.AppSettings {
    /**
     * Cesta k objetu předplnění hodnot v GStore.
     * 
     * @author  JSindelka
     * @date    30.04.2019
    */
    export const PovinAPreplnSettingsPath = "Global.Pod.AppSettings.PodPodaniPovinAPreplnSettings"

    /**
     * Vrátí hodnoty uživatelskéhopředplnění hodnot.
     *
     * @author  JSindelka
     * @date    30.04.2019
     *  
     * @returns {Gordic.Pod.WebControls.GPodPodaniPovinAPreplnSettingsDto} Hodnoty uživatelskéhopředplnění hodnot.
     */
    export function GetPodPodaniPovinAPreplnSettings(): Gordic.Pod.WebControls.GPodPodaniPovinAPreplnSettingsDto {
        const settings: Gordic.Pod.WebControls.GPodPodaniPovinAPreplnSettingsDto | null | undefined = (window as any).gstor.get(PovinAPreplnSettingsPath, true);
        if (settings) {
            return settings;
        } else {
            return {  

            };
        }
    }

    /**
     * Nastaví hodnoty uživatelského předplnění hodnot.
     *  
     * @author  JSindelka
     * @date    30.04.2019
     *  
     * @param {Gordic.Pod.WebControls.GPodPodaniPovinAPreplnSettingsDto | null} value Hodnoty uživatelského předplnění hodnot.
     */
    export function SetPodPodaniPovinAPreplnSettings(value: Gordic.Pod.WebControls.GPodPodaniPovinAPreplnSettingsDto | null): void {
        (window as any).gstor.set(PovinAPreplnSettingsPath, value);
    }

    /**
     * Formulář uživatelského nastavení vypravení.
     *
     * @author  JSindelka
     * @date    30.04.2019
     */
    export function PodPodaniPovinAPreplnSettingsForm(): Forms.Form {
        const formName = "PodPodaniPovinAPreplnSettings";
        let modelProperty: (keyof Gordic.Pod.WebControls.GPodPodaniPovinAPreplnSettingsDto) | undefined;

        const form = new Gordic.Forms.Form({
            name: formName,
            tabOptions: {
                title: "jres:31950367", //RC 31950367 : Povinné položky a předplnění (Dialog profilu dokumentu v podatelně)
                opened: false
            },
            layoutDescriptor:"L2M2S1"
            
        } as any);

        form.addSection("jres:31950102") //RC 31950102 : Nastavení povinnosti položek pro dialog profilu dokumentu v podatelně.

        form.addRow().addField("gcheck", {
            name: "PovinVec",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PovinVec") + "=value",
            label: "jres:23900083",  //RC 23900083 : Věc

        });
        form.addRow().addField("gcheck", {
            name: "PovinPSC",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PovinPSC") + "=value",
            label: "jres:23900084", //RC 23900084 : PSČ

        });
        form.addRow().addField("gcheck", {
            name: "PovinStat",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PovinStat") + "=value",
            label: "jres:31950103", //RC 31950103 : Stát

        });
        form.addRow().addField("gcheck", {
            name: "PovinDatOdes",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PovinDatOdes") + "=value",
            label: "jres:31950104", //RC 31950104 : Datum odeslání

        });
        form.addRow().addField("gcheck", {
            name: "PovinDatZeDne",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PovinDatZeDne") + "=value",
            label: "jres:31950105", //RC 31950105 : Datum ze dne

        });
        form.addRow().addField("gcheck", {
            name: "PovinZnackaOdes",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PovinZnackaOdes") + "=value",
            label: "jres:31950106", //RC 31950106 : Značka odesilatele

        });
        form.addRow().addField("gcheck", {
            name: "PovinOdesilatel",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PovinOdesilatel") + "=value",
            label: "jres:31950073", //RC 31950073 : Odesílatel

        });
        form.addRow().addField("gcheck", {
            name: "PovinPodCislo",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PovinPodCislo") + "=value",
            label: "jres:31950107"  //RC 31950107 : Podací číslo
                + " (jres:31950385)" //RC 31950385 : pouze pro způsob doručení: pošta, kurýr
            , 

        });
        form.addRow().addField("gcheck", {
            name: "PovinPozn",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PovinPozn") + "=value",
            label: "jres:23900059", //RC 23900059 : Poznámka

        });
        form.addRow().addField("gcheck", {
            name: "PovinPocListu",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PovinPocListu") + "=value",
            label: "jres:31950108", //RC 31950108 : Počet listů

        });
        form.addRow().addField("gcheck", {
            name: "PovinPocStran",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PovinPocStran") + "=value",
            label: "jres:31950109", //RC 31950109 : Počet stran

        });
        form.addRow().addField("gcheck", {
            name: "PovinPocPriloh",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PovinPocPriloh") + "=value",
            label: "jres:31950110", //RC 31950110 : Počet příloh

        });
        form.addRow().addField("gcheck", {
            name: "PovinPocListuPriloh",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PovinPocListuPriloh") + "=value",
            label: "jres:31950111", //RC 31950111 : Počet listů příloh

        });
        form.addRow().addField("gcheck", {
            name: "PovinPocKopii",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PovinPocKopii") + "=value",
            label: "jres:31950112", //RC 31950112 : Počet kopií

        });
        form.addRow().addField("gcheck", {
            name: "PovinCilPrideleni",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PovinCilPrideleni") + "=value",
            label: "jres:31950113", //RC 31950113 : Cíl přidělení

        });
        form.addRow().addField("gcheck", {
            name: "PovinVecPodrobne",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PovinVecPodrobne") + "=value",
            label: "jres:31950114", //RC 31950114 : Věc podrobně

        });



        form.addSection("jres:31950115") //RC 31950115 : Předplňování položek z předchozího podání nového cizího dokumentu (Dialog profilu dokumentu v podatelně)
        form.addRow().addField("gcheck", {
            name: "PredVec",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredVec") + "=value",
            label: "jres:23900083", //RC 23900083 : Věc

        });
        form.addRow().addField("gcheck", {
            name: "PredPSC",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredPSC") + "=value",
            label: "jres:23900084", //RC 23900084 : PSČ

        });
        form.addRow().addField("gcheck", {
            name: "PredStat",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredStat") + "=value",
            label: "jres:31950103", //RC 31950103 : Stát

        });
        form.addRow().addField("gcheck", {
            name: "PredSPZ",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredSPZ") + "=value",
            label: "jres:31950116", //RC 31950116 : SPZ

        });
        form.addRow().addField("gcheck", {
            name: "PredPredat",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredPredat") + "=value",
            label: "jres:31950117", //RC 31950117 : Předat

        });
        form.addRow().addField("gcheck", {
            name: "PredDatOdes",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredDatOdes") + "=value",
            label: "jres:31950118", //RC 31950118 : Datum odeslánís

        });
        form.addRow().addField("gcheck", {
            name: "PredDatZeDne",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredDatZeDne") + "=value",
            label: "jres:31950105", //RC 31950105 : Datum ze dne

        });
        form.addRow().addField("gcheck", {
            name: "PredZnackaOdes",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredZnackaOdes") + "=value",
            label: "jres:31950119", //RC 31950119 : Značka odesílateles

        });
        form.addRow().addField("gcheck", {
            name: "PredVecPodrobne",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredVecPodrobne") + "=value",
            label: "jres:31950114", //RC 31950114 : Věc podrobně

        });
        form.addRow().addField("gcheck", {
            name: "PredPridelitPrimo",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredPridelitPrimo") + "=value",
            label: "jres:31950120", //RC 31950120 : Přidělit přímo

        });
        form.addRow().addField("gcheck", {
            name: "PredSpZnOdes",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredSpZnOdes") + "=value",
            label: "jres:31950121", //RC 31950121 : Sp. zn. odes.

        });
        form.addRow().addField("gcheck", {
            name: "PredOdesilatel",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredOdesilatel") + "=value",
            label: "jres:31950073", //RC 31950073 : Odesílatel

        });
        form.addRow().addField("gcheck", {
            name: "PredPodCislo",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredPodCislo") + "=value",
            label: "jres:31950107", //RC 31950107 : Podací číslo

        });
        form.addRow().addField("gcheck", {
            name: "PredPoznamka",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredPoznamka") + "=value",
            label: "jres:23900059", //RC 23900059 : Poznámka

        });
        form.addRow().addField("gcheck", {
            name: "PredCilPrideleni",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredCilPrideleni") + "=value",
            label: "jres:31950113", //RC 31950113 : Cíl přidělení

        });
        form.addRow().addField("gcheck", {
            name: "PredPocList",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredPocList") + "=value",
            label: "jres:31950108", //RC 31950108 : Počet listů

        });
        form.addRow().addField("gcheck", {
            name: "PredPocStran",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredPocStran") + "=value",
            label: "jres:31950109", //RC 31950109 : Počet stran

        });
        form.addRow().addField("gcheck", {
            name: "PredPocPriloh",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredPocPriloh") + "=value",
            label: "jres:31950110", //RC 31950110 : Počet příloh

        });
        form.addRow().addField("gcheck", {
            name: "PredPocKopii",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredPocKopii") + "=value",
            label: "jres:31950112", //RC 31950112 : Počet kopií

        });
        form.addRow().addField("gcheck", {
            name: "PredPocListuPriloh",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredPocListuPriloh") + "=value",
            label: "jres:31950111", //RC 31950111 : Počet listů příloh

        });
        form.addRow().addField("gcheck", {
            name: "PredZpusobDor",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredZpusobDor") + "=value",
            label: "jres:23900010", //RC 23900010 : Způsob doručení

        });
        form.addRow().addField("gcheck", {
            name: "PredDruhZach",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredDruhZach") + "=value",
            label: "jres:31950122", //RC 31950122 : Druh zacházení

        });
        form.addRow().addField("gcheck", {
            name: "PredDruhZas",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredDruhZas") + "=value",
            label: "jres:31950123", //RC 31950123 : Druh zásilky

        });
        form.addRow().addField("gcheck", {
            name: "PredTypDok",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredTypDok") + "=value",
            label: "jres:31950078", //RC 31950078 : Typ dokumentu

        });
        form.addRow().addField("gcheck", {
            name: "PredDatPod",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "PredDatPod") + "=value",
            label: "jres:31950068", //RC 31950068 : Datum podání

        });

        form.addSection("jres:31950124") //RC 31950124 : Nastavení předplňování položek aktuálním datem
        form.addRow().addField("gcheck", {
            name: "AktDatumDatOdes",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "AktDatumDatOdes") + "=value",
            label: "jres:31950104", //RC 31950104 : Datum odeslání

        });
        form.addRow().addField("gcheck", {
            name: "AktDatumDatZeDne",
            model: PovinAPreplnSettingsPath + "." + (modelProperty = "AktDatumDatZeDne") + "=value",
            label: "jres:31950105", //RC 31950105 : Datum ze dne

        });
        return form;
    }
}